export default defineNuxtPlugin((nuxtApp) => {
  useScript({
    src: 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=onloadFunction',
  });
});